import React, { useMemo } from 'react';
import DENTMultipleSelectListItemActions from '../../DENTMultipleSelectList/DENTMultipleSelectListItemActions';
import useTranslation from '../../../../../Hooks/useTranslation';
import { SURFACES_TRANSLATION_MAP } from '../../../Helpers/surfaces/surfacesTranslationMap.helper';
import { RESTORATION_TRANSLATION_MAP } from '../../../Helpers/restoration/restorationTranslationMap.helper';
import styles from './DENTModalOverviewRestorationFillingListItem.module.scss';
import { ToothRestorationFilling } from '../../../../../graphql/graphql';

interface Props {
	filling: ToothRestorationFilling;
	handleEdit: () => void;
	handleDelete: () => void;
}

const DENTModalOverviewRestorationFillingListItem = ({
	filling,
	handleEdit,
	handleDelete,
}: Props) => {
	const { t } = useTranslation();

	const translatedSurfaces = useMemo(
		() =>
			filling.surfaces
				.map(surface => t(SURFACES_TRANSLATION_MAP[surface]))
				.join(', '),
		[filling.surfaces],
	);

	const translatedValues = useMemo(() => {
		return [
			filling.values?.material,
			filling.values?.quality,
			filling.values?.detail,
		]
			.filter(Boolean)
			.map(value => t(RESTORATION_TRANSLATION_MAP[value!]))
			.join(', ');
	}, [filling.values]);

	if (!filling.surfaces.length) {
		return <></>;
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.item}>
				{translatedValues && <span>{translatedValues}</span>}
				{translatedSurfaces && <span>{translatedSurfaces}</span>}
			</div>
			<DENTMultipleSelectListItemActions
				handleEdit={handleEdit}
				handleDelete={handleDelete}
			/>
		</div>
	);
};

export default DENTModalOverviewRestorationFillingListItem;
